import { ClubDetails } from '../club/club';

export class Structure {
    structureKey?: number;
    structureName: string;
    clubs: ClubDetails[];

    constructor(structureName: string, clubs: ClubDetails[], structureKey?: number) {
        this.structureName = structureName;
        this.clubs = clubs;
        this.structureKey = structureKey;
    }
}

